import React, { useState, useEffect } from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";
import IconComponent from "../../components/icon/Icon";
import HelpList from "../../components/helplist/HelpList";
import FAQAccordion from "../../components/homefaq/FAQAccordion";

function ContactUsCTR() {
  const companyemail = "contact@bonvoytourism.com";
  const companyphone = "+971559215470";
  // const companyaddress = "Al Saqar Business Tower, Office 117, Sheikh Zayed Rd, Trade Center Second, DIFC, Dubai, United Arab Emirates";
  const companyaddress = "Dubai, United Arab Emirates";
  const companymapsLink = "https://www.google.com/maps/place/Bonvoy+Tourism+%7C+Desert+Safari+And+Tours+Dubai+%7C+Park+Tickets+%7C+Dubai+City+Tour/@25.214,55.277845,9z/data=!4m6!3m5!1s0x3e5f43becd0c7e27:0xdf96e3a5a5936a71!8m2!3d25.2139997!4d55.2778447!16s%2Fg%2F11wc9221z2?hl=en&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";
  const companywhatsappLink = `https://wa.me/${companyphone}`;
  const companytime = "Monday–Sunday, 8:00 AM–10:00 PM tours available 24/7 — call anytime";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => setStatus(""), 8000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  useEffect(() => {
    const fallbackTimer = setTimeout(() => setIsMapLoaded(true), 3000);
    return () => clearTimeout(fallbackTimer);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("");

    try {
      const response = await fetch("https://bonvoytourism.com/bonvoytourismbackend/api/contactus", {
        // const response = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/contactus", {
        // const response = await fetch("http://localhost:3000/bonvoytourismbackend/api/contactus", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus("Message sent successfully! We'll get back to you soon.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus(result.error || "Failed to send message. Please try again.");
      }
    } catch (error) {
      setStatus("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMapLoad = () => setIsMapLoaded(true);

  const faqs = [
    {
      question: "Can I do both the morning and evening safari on the same day?",
      answer:
        "Technically yes, but we would not recommend it. Both tours involve dune bashing which can be physically tiring. It is much better to experience them on separate days so you can fully enjoy each one.",
    },
    {
      question: "Which safari is better for taking photos?",
      answer:
        "Both are great, but for different reasons. Morning light (golden hour) produces softer, warmer, more dramatic photography. Evening has the sunset and the vibrant atmosphere of the lit camp, which makes for compelling people photography. If landscape photography is your goal, morning wins. If you want atmosphere and people shots, evening wins.",
    },
  ];

  // const helpItems = [
  //   "Book a specific tour — we can confirm availability and process your booking in minutes",
  //   "Create a custom itinerary for your entire Dubai trip",
  //   "Arrange group tours for 10, 20, 50 or 100+ people",
  //   "Organise corporate team outings, incentive trips or company events in the desert",
  //   "Get advice on the best tours for your travel dates, group size or budget",
  //   "Request a private or VIP experience tailored entirely to your preferences",
  //   "Ask about airport transfers, hotel recommendations or other Dubai logistics",
  // ];
  const helpItems = [
    {
      heading: "Book a specific tour",
      desc: "We can confirm availability and process your booking in minutes.",
    },
    {
      heading: "Create a custom itinerary",
      desc: "We'll plan your entire Dubai trip from start to finish.",
    },
    {
      heading: "Arrange group tours",
      desc: "We cater for groups of 10, 20, 50 or 100+ people with ease.",
    },
    {
      heading: "Organise corporate events",
      desc: "Team outings, incentive trips or company events in the desert — we handle it all.",
    },
    {
      heading: "Get expert advice",
      desc: "We'll recommend the best tours for your travel dates, group size or budget.",
    },
    {
      heading: "Request a private or VIP experience",
      desc: "Tell us what you want and we'll tailor every detail to your preferences.",
    },
    {
      heading: "Ask about Dubai logistics",
      desc: "Airport transfers, hotel recommendations and anything else you need.",
    },
  ];

  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="Get in Touch"
        para="We're Here 24/7 to Help You Plan Your Perfect Dubai Experience"
      />

      <div className="w-full mt-12 md:mt-22 relative">
        {!isMapLoaded && (
          <div className="w-full h-[450px] bg-gray-200 animate-pulse rounded-[4px]" />
        )}
        <iframe
          title="Bonvoy Tourism Location Map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d924078.1701508961!2d55.277845!3d25.214!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43becd0c7e27%3A0xdf96e3a5a5936a71!2sBonvoy%20Tourism%20%7C%20Desert%20Safari%20And%20Tours%20Dubai%20%7C%20Park%20Tickets%20%7C%20Dubai%20City%20Tour!5e0!3m2!1sen!2s!4v1767944981575!5m2!1sen!2s"
          width="100%"
          height="450"
          style={{
            border: 0,
            display: isMapLoaded ? "block" : "none",
            borderRadius: "4px",
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={handleMapLoad}
        ></iframe>
      </div>

      <div>
        <h3 className="text-[#666] font-semibold text-[24px] md:text-[28px] mt-12 md:mt-22 mb-2">
          We're Here to Help
        </h3>
        <p className="text-[14px] md:text-[16px] text-[#4E4E4E] leading-relaxed">
          Whether you have a specific tour in mind, want to build a custom itinerary, are travelling as a large group, or simply have a question you cannot find the answer to — we would love to hear from you. Our team is available around the clock, every day of the year. No chatbots, no automated responses, no wait times. Just a real person who loves Dubai and wants to help you make the most of your visit.</p>
      </div>

      {/* Form Section */}
      <div className="flex flex-col md:flex-row gap-12 md:gap-30 justify-between mt-12 md:mt-22">
        <div className="flex-[3]">
          <form className="w-full text-[13px] space-y-4" onSubmit={handleSubmit}>
            <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/user.png" alt="user" width={16} height={16} />
              <input
                className="w-full outline-none"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
            </div>

            <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/email.png" alt="email" width={16} height={16} />
              <input
                className="w-full outline-none"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
              />
            </div>

            <div className="flex gap-[12px] items-start w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/chat.png" alt="chat" width={16} height={16} />
              <textarea
                className="w-full outline-none resize-none"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows={8}
                required
              />
            </div>

            <button
              type="submit"
              className="bg-[#ff9219] text-white py-[10px] px-[50px] rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Now"}
            </button>
          </form>

          {status && (
            <p
              className={`text-[13px] text-white mt-4 py-[10px] px-[50px] text-center rounded-[4px] ${status.includes("successfully") ? "bg-[#ff9219]" : "bg-red-600"
                }`}
            >
              {status}
            </p>
          )}
        </div>

        {/* Contact Info Section */}
        <div className="space-y-4 flex-1">
          <h3 className="text-[18px] font-medium text-[#606060]">Contact Information</h3>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <a
            href={companymapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-[13px] font-medium text-[#606060] hover:text-[#ff9219] transition"
          >
            {companyaddress}
          </a>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>PHONE:</p>
            <a
              href={`tel:${companyphone}`}
              className="hover:text-[#ff9219] transition"
            >
              {companyphone}
            </a>
          </div>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>WHATSAPP:</p>
            <a
              href={companywhatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#ff9219] transition"
            >
              Chat on WhatsApp
            </a>
          </div>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>EMAIL:</p>
            <a
              href={`mailto:${companyemail}`}
              className="hover:text-[#ff9219] transition"
            >
              {companyemail}
            </a>
          </div>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>Hours:</p>
            <p>{companytime}</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row lg:gap-12 items-start">
        <div className="flex-1">
          <HelpList
            title="What Can We Help You With?"
            items={helpItems}
          />
        </div>
        <div className="flex-1">
          <FAQAccordion data={faqs} />
        </div>
      </div>
    </div>
  );
}

export default ContactUsCTR;
